import * as React from 'react';
import {useCallback, useState} from 'react';
import styled from 'styled-components'
import {ConstBorderRound, ConstColor} from "../../../config/styles_const/styles_const";
import BtnBorderSmall from '../atom/btn/btn_border_small';
import BtnCorporateSmall from '../atom/btn/btn_corporate_small';
import OuterLink from '../atom/outer_link';
import ParagraphSup from "../atom/text/paragraph_sup";

interface IProps {
    information: string;
    subInformation?: string;
    linkURL?: string;
    linkText?: string;
}

const PageTopInfo: React.FC<IProps> = (props) => {

    const { information, subInformation, linkURL, linkText } = props;

    const [isInfo, setIsInfo] = useState<boolean>(true);

    const handleClickInfoClose = useCallback(async() => {
        setIsInfo(false);
    }, [])

    return (
        <>
            {isInfo &&
                <PageTopInfoWrapper>
                    <InformationWrapper>
                        <MessageWrapper>
                            <MessageText bold={true}>{information}</MessageText>
                            <TimeButton onClick={handleClickInfoClose} icon={"'\f00d'"} />
                        </MessageWrapper>
                        {subInformation && <ParagraphSup >{subInformation}</ParagraphSup> }
                    </InformationWrapper>
                    {linkURL &&
                        <BtnWrapper>
                            <OuterLink href={linkURL} target="_blank" rel="noopener">
                                <BtnCorporateSmall>{ linkText ? linkText : "詳細はこちら" }</BtnCorporateSmall>
                            </OuterLink>
                        </BtnWrapper>
                    }
                </PageTopInfoWrapper>
            }
        </>
    )

};

export default PageTopInfo;

const PageTopInfoWrapper = styled.div`
    padding: 20px;
    background: ${ConstColor.TableTh};
    border-radius: ${ConstBorderRound.CornerRoundAll};
    margin-bottom: 20px;
    
`;

const InformationWrapper = styled.div`
`

const MessageWrapper = styled.div`
    display: flex;
    margin-bottom: 15px;
`

const MessageText = styled(ParagraphSup)`
    max-width: 90%;
`

const TimeButton = styled(BtnBorderSmall)`
    line-height: inherit;
    height: fit-content;
    border-radius: ${ConstBorderRound.CornerRoundAll};
    background-color: ${ConstColor.TableTh};
    border: none;
    margin-left: auto;
    color: ${ConstColor.Base};
    padding: 0;
    &:before {
        margin-right: 0;
    }
`

const BtnWrapper = styled.div`
    
`



// WEBPACK FOOTER //
// ./src/presentation/common/organism/page_top_info.tsx